import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CalendarDays, Clock, Hourglass, MonitorPlay, Users } from "lucide-react";
import { fileUrl, fmtDate, fmtPrice, fmtTime } from "@/lib/api";

const Meta = ({ Icon, children }) => (
  <div className="flex items-center gap-2 text-sm text-[var(--muted-ink)]"><Icon size={15} className="text-[var(--copper)] shrink-0" /><span>{children}</span></div>
);

export const SeatsBadge = ({ course }) => {
  const full = course.seats_left <= 0;
  return (
    <span data-testid={`seats-badge-${course.id}`} className={`text-xs font-bold px-3 py-1 rounded-full ${full ? "bg-red-100 text-red-700" : "bg-[#D4AF37]/15 text-[#8a6a10]"}`}>
      {full ? "اكتملت المقاعد" : `متبقٍ ${course.seats_left} من ${course.seats_total} مقعد`}
    </span>
  );
};

export const CourseCard = ({ course, index = 0 }) => (
  <motion.article
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.5, delay: index * 0.08 }}
    className="card-lux overflow-hidden flex flex-col"
    data-testid={`course-card-${course.id}`}
  >
    <div className="relative aspect-[16/9] overflow-hidden">
      <img src={fileUrl(course.image) || "/images/course-ai.jpg"} alt={course.title} className="w-full h-full object-cover transition-transform duration-700 hover:scale-105" loading="lazy" />
      <span className="absolute top-3 right-3 bg-white/90 backdrop-blur text-xs font-semibold px-3 py-1 rounded-full text-[var(--copper)]">{course.category}</span>
      <span className="absolute bottom-3 left-3 bg-[#1F1815]/85 text-white font-display font-bold px-4 py-1.5 rounded-full" data-testid={`course-price-${course.id}`}>{fmtPrice(course.price)}</span>
    </div>
    <div className="p-6 flex flex-col gap-4 flex-1">
      <h3 className="font-display text-lg font-bold leading-snug text-[var(--ink)]">{course.title}</h3>
      <p className="text-sm leading-relaxed text-[var(--muted-ink)] line-clamp-3">{course.short_description}</p>
      <div className="grid grid-cols-2 gap-2.5">
        <Meta Icon={CalendarDays}>{fmtDate(course.date)}</Meta>
        <Meta Icon={Clock}>{fmtTime(course.time)}</Meta>
        <Meta Icon={Hourglass}>{course.duration_label}</Meta>
        <Meta Icon={MonitorPlay}>{course.mode}</Meta>
      </div>
      <div className="flex items-center gap-2"><Users size={15} className="text-[var(--copper)]" /><SeatsBadge course={course} /></div>
      <div className="mt-auto flex gap-3 pt-2">
        <Link to={`/courses/${course.slug || course.id}`} className="btn-gold-outline flex-1 !py-2.5 text-sm" data-testid={`course-details-btn-${course.id}`}>التفاصيل</Link>
        {course.can_register ? (
          <Link to={`/enroll/${course.id}`} className="btn-copper flex-1 !py-2.5 text-sm" data-testid={`course-register-btn-${course.id}`}>سجّل الآن</Link>
        ) : (
          <button disabled className="btn-copper flex-1 !py-2.5 text-sm" data-testid={`course-register-btn-${course.id}`}>التسجيل مغلق</button>
        )}
      </div>
    </div>
  </motion.article>
);
